export const EmployeeSortEnum = {
    NAME: "name",
    NAME_ASC: "last_name",
    NAME_DESC: "-last_name",
    FUNCTION_GROUP: "function_group",
    FUNCTION_GROUP_ASC: "function_group",
    FUNCTION_GROUP_DESC: "-function_group",
    ROLE: "role",
    ROLE_ASC: "role",
    ROLE_DESC: "-role",
    ACHIEVED_CERTIFICATES: "achieved_certificates",
    ACHIEVED_CERTIFICATES_ASC: "achieved_qualifications_count",
    ACHIEVED_CERTIFICATES_DESC: "-achieved_qualifications_count",
    MISSING_CERTIFICATES: "missing_certificates",
    MISSING_CERTIFICATES_ASC: "missing_qualifications_count",
    MISSING_CERTIFICATES_DESC: "-missing_qualifications_count",
    EXPIRING_CERTIFICATES: "expiring_certificates",
    EXPIRING_CERTIFICATES_ASC: "expiring_soon_certificates_count",
    EXPIRING_CERTIFICATES_DESC: "-expiring_soon_certificates_count",
};
